/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_Main_NavigationInputs */

const en_nav_aria_main_navigation = /** @type {(inputs: Nav_Aria_Main_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

const es_nav_aria_main_navigation = /** @type {(inputs: Nav_Aria_Main_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación principal`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Nav_Aria_Main_NavigationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aria_main_navigation = /** @type {((inputs?: Nav_Aria_Main_NavigationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_Main_NavigationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_aria_main_navigation(inputs)
	return en_nav_aria_main_navigation(inputs)
});